module.exports = __webpack_public_path__ + "static/img/battle-monsters@3x.5121e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-page/battle-monsters@3x.png
// module id = mp8r
// module chunks = 1